import global from './global.js';
import config from './config.js';
import { playerUtils } from './playerUtils.js';

class Canvas {
   constructor(params) {
        this.directionLock = false;
        this.target = { x: 0, y: 0 };
        this.reenviar = true;
        this.socket = global.socket;
        this.directions = [];
        var self = this;

        this.cv = document.getElementById('cvs');
        this.cv.width = global.screen.width;
        this.cv.height = global.screen.height;
        this.cv.addEventListener('mousemove', this.gameInput.bind(this), false);
        this.cv.addEventListener('mouseout', this.outOfBounds.bind(this), false);
        this.cv.addEventListener('keypress', this.keyInput.bind(this), false);
        this.cv.addEventListener('keyup', this.directionUp.bind(this), false);
        this.cv.addEventListener('keydown', this.directionDown.bind(this), false);
        this.cv.addEventListener('touchstart', this.touchInput.bind(this), false);
        this.cv.addEventListener('touchmove', this.touchInput.bind(this), false);
        this.cv.addEventListener('touchend', this.touchEnd.bind(this), false);
        this.cv.parent = this;
        global.canvas = this;
        this.moveSpeed = 5; // Adjust this value to change movement speed
        this.touchController = {
            active: false,
            startX: 0,
            startY: 0,
            x: 0,
            y: 0
        };
        this.joystick = {
            active: false,
            startX: 0,
            startY: 0,
            moveX: 0,
            moveY: 0,
            radius: 50,
            innerRadius: 20
        };

        global.target = this.target; // Set global target to match this.target

        // Bind all methods that need 'this' context
        this.directionDown = this.directionDown.bind(this);
        this.directionUp = this.directionUp.bind(this);
        this.directional = this.directional.bind(this);
        this.newDirection = this.newDirection.bind(this);
        this.updateTarget = this.updateTarget.bind(this);
        this.horizontal = this.horizontal.bind(this);
        this.vertical = this.vertical.bind(this);
        this.keyInput = this.keyInput.bind(this);
    }

    // Function called when a key is pressed, will change direction if arrow key.
    directionDown(event) {
        var key = event.which || event.keyCode;
        if (this.directional(key)) {
            this.directionLock = true;
            if (this.newDirection(key, this.directions, true)) {
                this.updateTarget(this.directions);
                // Removed: this.socket.emit('0', this.target);
            }
        }
    }

    // Function called when a key is lifted, will change direction if arrow key.
    directionUp(event) {
        var key = event.which || event.keyCode;
        if (this.directional(key)) {
            if (this.newDirection(key, this.directions, false)) {
                this.updateTarget(this.directions);
                if (this.directions.length === 0) this.directionLock = false;
                // Removed: this.socket.emit('0', this.target);
            }
        }
    }

    // Updates the direction array including information about the new direction.
    newDirection(direction, list, isAddition) {
    	var result = false;
    	var found = false;
    	for (var i = 0, len = list.length; i < len; i++) {
    		if (list[i] == direction) {
    			found = true;
    			if (!isAddition) {
    				result = true;
    				// Removes the direction.
    				list.splice(i, 1);
    			}
    			break;
    		}
    	}
    	// Adds the direction.
    	if (isAddition && found === false) {
    		result = true;
    		list.push(direction);
    	}

    	return result;
    }

    // Updates the target according to the directions in the directions array.
    updateTarget(list) {
        var directionHorizontal = 0;
        var directionVertical = 0;
        for (var i = 0, len = list.length; i < len; i++) {
            if (directionHorizontal === 0) {
                if (list[i] == global.KEY_LEFT) directionHorizontal -= this.moveSpeed;
                else if (list[i] == global.KEY_RIGHT) directionHorizontal += this.moveSpeed;
            }
            if (directionVertical === 0) {
                if (list[i] == global.KEY_UP) directionVertical -= this.moveSpeed;
                else if (list[i] == global.KEY_DOWN) directionVertical += this.moveSpeed;
            }
        }
        
        if (directionHorizontal !== 0 || directionVertical !== 0) {
            this.target.x += directionHorizontal;
            this.target.y += directionVertical;
            global.target = this.target;
        } else if (this.target.x !== 0 || this.target.y !== 0) {
            // If no direction is pressed and the target is not at (0,0), reset it
            this.target.x = 0;
            this.target.y = 0;
            global.target = this.target;
        }
    }

    directional(key) {
    	return this.horizontal(key) || this.vertical(key);
    }

    horizontal(key) {
    	return key == global.KEY_LEFT || key == global.KEY_RIGHT;
    }

    vertical(key) {
    	return key == global.KEY_DOWN || key == global.KEY_UP;
    }

    // Register when the mouse goes off the canvas.
    outOfBounds() {
        this.directionLock = true;
        this.target.x = 0;
        this.target.y = 0;
        global.target = this.target;
    }

    gameInput(mouse) {
        if (!global.isMobile) {
            const rect = this.cv.getBoundingClientRect();
            const scaleX = this.cv.width / rect.width;
            const scaleY = this.cv.height / rect.height;
            
            const mouseX = (mouse.clientX - rect.left) * scaleX;
            const mouseY = (mouse.clientY - rect.top) * scaleY;
            
            const centerX = this.cv.width / 2;
            const centerY = this.cv.height / 2;
            
            const dx = mouseX - centerX;
            const dy = mouseY - centerY;
            
            const distance = Math.sqrt(dx * dx + dy * dy);
            const maxDistance = Math.min(this.cv.width, this.cv.height) / 2;
            
            const speed = Math.min(distance / maxDistance, 1) * this.moveSpeed;
            
            this.target.x = dx / distance * speed;
            this.target.y = dy / distance * speed;
            
            global.target = this.target;
        }
    }

    touchInput(touch) {
        global.isMobile = true;
        touch.preventDefault();
        touch.stopPropagation();
        
        if (touch.touches.length === 1) {
            const touchX = touch.touches[0].clientX;
            const touchY = touch.touches[0].clientY;
            
            if (!this.joystick.active) {
                this.joystick.active = true;
                this.joystick.startX = touchX;
                this.joystick.startY = touchY;
            }
            this.joystick.moveX = touchX;
            this.joystick.moveY = touchY;
            this.updateJoystickTarget();
        }
    }

    updateJoystickTarget() {
        if (this.joystick.active) {
            const dx = this.joystick.moveX - this.joystick.startX;
            const dy = this.joystick.moveY - this.joystick.startY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            const maxDistance = this.joystick.radius;
            
            let angle = Math.atan2(dy, dx);
            let speed = Math.min(distance / maxDistance, 1) * this.moveSpeed;
            
            // Limit the maximum speed
            const maxSpeed = 2.5;
            speed = Math.min(speed, maxSpeed);
            
            this.target.x = Math.cos(angle) * speed;
            this.target.y = Math.sin(angle) * speed;
            global.target = this.target;
        }
    }

    handleFeedButtonDrag(touchX, touchY) {
        if (!this.feedDragStart) {
            this.feedDragStart = { x: touchX, y: touchY };
        }
        
        const dx = touchX - this.feedDragStart.x;
        const dy = touchY - this.feedDragStart.y;
        const angle = Math.atan2(dy, dx);
        const distance = Math.sqrt(dx * dx + dy * dy);
        const maxDistance = 50; // Maximum drag distance for full speed
        
        let speed = Math.min(distance / maxDistance, 1);
        
        this.target.x = Math.cos(angle) * speed * this.moveSpeed;
        this.target.y = Math.sin(angle) * speed * this.moveSpeed;
        global.target = this.target;
    }

    // Chat command callback functions.
    keyInput(event) {
    	var key = event.which || event.keyCode;
    	if (key === global.KEY_SPLIT && this.reenviar) {
            this.reenviar = false;
            // Implement your split logic here
            // For example: global.socket.emit('2');
            // Or call a method to handle splitting
        }
        else if (key === global.KEY_FIREFOOD && this.reenviar) {
            this.reenviar = false;
            // Implement your firefood logic here
            // For example: global.socket.emit('1');
            // Or call a method to handle firing food
        }
        else if (key === global.KEY_CHAT) {
            // Implement your chat toggle logic here
            // For example: global.chat.toggleChat();
        }
    }

    drawTouchController(ctx) {
        if (this.joystick.active) {
            ctx.save();
            ctx.fillStyle = 'rgba(255, 255, 255, 0.2)';
            ctx.beginPath();
            ctx.arc(this.joystick.startX, this.joystick.startY, this.joystick.radius, 0, 2 * Math.PI);
            ctx.fill();

            ctx.strokeStyle = 'rgba(255, 255, 255, 0.8)';
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.arc(this.joystick.startX, this.joystick.startY, this.joystick.radius, 0, 2 * Math.PI);
            ctx.stroke();
            
            const dx = this.joystick.moveX - this.joystick.startX;
            const dy = this.joystick.moveY - this.joystick.startY;
            const distance = Math.sqrt(dx * dx + dy * dy);
            const angle = Math.atan2(dy, dx);
            
            const innerX = this.joystick.startX + Math.cos(angle) * Math.min(distance, this.joystick.radius);
            const innerY = this.joystick.startY + Math.sin(angle) * Math.min(distance, this.joystick.radius);
            
            ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
            ctx.beginPath();
            ctx.arc(innerX, innerY, this.joystick.innerRadius, 0, 2 * Math.PI);
            ctx.fill();
            
            ctx.restore();
        }
    }

    touchEnd(event) {
        event.preventDefault();
        event.stopPropagation();

        this.joystick.active = false;
        this.directionLock = true;
        this.target.x = 0;
        this.target.y = 0;
        global.target = this.target;
    }
}

export default Canvas;
